import {
  ChannelOptions,
  WidgetConfigResponse,
} from '../../../types/widgetConfig';

// Current view states
export enum WidgetViewState {
  LANDING_PAGE = 'LANDING_PAGE',
  CHAT_WINDOW = 'CHAT_WINDOW',
  CHANNEL_DETAIL = 'CHANNEL_DETAIL',
  MINIMIZED = 'MINIMIZED',
}

// Widget opening manager props
export interface WidgetOpeningManagerProps {
  widgetConfig: WidgetConfigResponse;
}

// Navigation actions
export interface WidgetNavigationActions {
  goToLandingPage: () => void;
  goToChatWindow: () => void;
  goToChannelDetail: (channelType: keyof ChannelOptions) => void;
  minimize: () => void;
}
